import { render, staticRenderFns } from "./SearchUpgrade.vue?vue&type=template&id=4a4528fc&"
import script from "./SearchUpgrade.vue?vue&type=script&lang=js&"
export * from "./SearchUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports